'use client'
import React, { useEffect } from 'react'

const LoaderScripts = () => {
    useEffect(() => {
        document.documentElement.style.scrollBehavior = 'smooth'
    }, [])
    return null
}

export default LoaderScripts
